import outlookIcon from "../../assets/img/icons/Agent_app_logos/outlook.svg";
import gmailIcon from "../../assets/img/icons/svg/gmail.svg";
import whatsappIcon from "../../assets/img/icons/Agent_app_logos/whatsapp.svg"
import microsoftteamsIcon from "../../assets/img/icons/Agent_app_logos/microsoft-teams-icon.svg"
import zoomIcon from "../../assets/img/icons/Agent_app_logos/Zoom.svg"
import signalIcon from "../../assets/img/icons/Agent_app_logos/signal-app-icon.png"
import discordIcon from "../../assets/img/icons/Agent_app_logos/discord.svg"
import twitterIcon from "../../assets/img/icons/Agent_app_logos/Twitter.svg"
import mailchimpIcon from "../../assets/img/icons/Agent_app_logos/Mailchimp.svg"
import twilioIcon from "../../assets/img/icons/Agent_app_logos/Twilio Icon.svg"
import microsoftonedriveIcon from "../../assets/img/icons/Agent_app_logos/Microsoft onedrive.svg"
import zohoworkdriveIcon from "../../assets/img/icons/Agent_app_logos/Zoho workdrive.svg"
import googlebooksIcon from "../../assets/img/icons/Agent_app_logos/Google books.svg"
import zohobooksIcon from "../../assets/img/icons/Agent_app_logos/Zoho Books.svg"
import dropboxIcon from "../../assets/img/icons/Agent_app_logos/dropbox-1-logo-png-transparent.png"
import pinataIcon from "../../assets/img/icons/Agent_app_logos/pinata.png"
import sharepointIcon from "../../assets/img/icons/Agent_app_logos/Sharepoint.svg"
import pdfvectorIcon from "../../assets/img/icons/Agent_app_logos/pdf vector.svg"
import typeformIcon from "../../assets/img/icons/Agent_app_logos/Typeform.png"
import paperformIcon from "../../assets/img/icons/Agent_app_logos/paperform.jpeg"
import invoiceninjaIcon from "../../assets/img/icons/Agent_app_logos/Invoice ninja.svg"
import awsdynamoDBIcon from "../../assets/img/icons/Agent_app_logos/aws dynamodb.svg"
import thehiveIcon from "../../assets/img/icons/Agent_app_logos/the hive.png"
import supabaseIcon from "../../assets/img/icons/Agent_app_logos/Supabase.svg"
import awsIcon from "../../assets/img/icons/Agent_app_logos/AWS logo.svg"
import awslambdaIcon from "../../assets/img/icons/Agent_app_logos/AWS lambda.svg"
import awsiamIcon from "../../assets/img/icons/Agent_app_logos/aws-iam.svg"
import awssesIcon from "../../assets/img/icons/Agent_app_logos/AWS SES.png"
import awssnsIcon from '../../assets/img/icons/Agent_app_logos/AWS SNS.svg'
import s3datadogIcon from "../../assets/img/icons/Agent_app_logos/S3 Datadog.svg"
import googlecloudIcon from "../../assets/img/icons/Agent_app_logos/Google cloud.svg"
import googlepubsubIcon from "../../assets/img/icons/Agent_app_logos/Google pubsub.svg"
import azureIcon from "../../assets/img/icons/Agent_app_logos/Azure.svg"
import gitlabIcon from "../../assets/img/icons/Agent_app_logos/gitlab.svg"
import jenkinsIcon from "../../assets/img/icons/Agent_app_logos/jenkins.svg"
import salesforceIcon from "../../assets/img/icons/Agent_app_logos/salesforce.svg"
import zohocrmIcon from "../../assets/img/icons/Agent_app_logos/zoho_crm.svg"
import zendeskIcon from "../../assets/img/icons/Agent_app_logos/Zendesk.svg"
import pipedriveIcon from "../../assets/img/icons/Agent_app_logos/Pipedrive.svg"
import asanaIcon from "../../assets/img/icons/Agent_app_logos/asana.svg"
import jiraIcon from "../../assets/img/icons/Agent_app_logos/JIRA.svg"
import confluenceIcon from "../../assets/img/icons/Agent_app_logos/Confluence.svg"
import trelloIcon from "../../assets/img/icons/Agent_app_logos/Trello.svg"
import taigaIcon from "../../assets/img/icons/Agent_app_logos/Taiga.svg"
import googleadsIcon from "../../assets/img/icons/Agent_app_logos/Google ads.svg"
import adobeIcon from "../../assets/img/icons/Agent_app_logos/Adobe.svg"
import shopifyIcon from "../../assets/img/icons/Agent_app_logos/shopify.svg"
import  woocommerceIcon from "../../assets/img/icons/Agent_app_logos/Woo commerce.svg"
import bigcartelIcon from "../../assets/img/icons/Agent_app_logos/Big cartel.svg"
import paypalIcon from "../../assets/img/icons/Agent_app_logos/Paypal.svg"
import stripeIcon from "../../assets/img/icons/Agent_app_logos/stripe.svg"
import coingeckoIcon from "../../assets/img/icons/Agent_app_logos/coingecko.svg"
import  growwIcon from "../../assets/img/icons/Agent_app_logos/Groww.svg"
import rabbitmqIcon from "../../assets/img/icons/Agent_app_logos/Rabbitmq.svg"
import posthogIcon from "../../assets/img/icons/Agent_app_logos/Posthog.svg"
import grafanaIcon from "../../assets/img/icons/Agent_app_logos/Grafana.svg"
import elasticsearchIcon from "../../assets/img/icons/Agent_app_logos/elastic search.svg"
import googletasksIcon from "../../assets/img/icons/Agent_app_logos/google-tasks.png"
import microsofttodoIcon from "../../assets/img/icons/Agent_app_logos/Microsoft to do.svg"
import googlecontactsIcon from "../../assets/img/icons/Agent_app_logos/Google contacts.svg"
import dhlIcon from "../../assets/img/icons/Agent_app_logos/DHL.svg"
import shipheroIcon from "../../assets/img/icons/Agent_app_logos/shiphero.jpeg"
import googletranslateIcon from "../../assets/img/icons/Agent_app_logos/Google translate.svg"
import stravaIcon from "../../assets/img/icons/Agent_app_logos/strava.svg"
import godaddyIcon from "../../assets/img/icons/Agent_app_logos/Go Daddy.svg"
import wikipediaIcon from "../../assets/img/icons/Agent_app_logos/Wikipedia.svg"
import vimeoIcon from "../../assets/img/icons/Agent_app_logos/Vimeo.svg"
import smarthingsIcon from "../../assets/img/icons/Agent_app_logos/smart things.png"
import Auth0Icon from "../../assets/img/icons/Agent_app_logos/Auth 0.svg"
import keycloakIcon from "../../assets/img/icons/Agent_app_logos/keycloak.svg"
import cognitoIcon from "../../assets/img/icons/Agent_app_logos/aws-cognito.svg"
import oktaIcon from "../../assets/img/icons/Agent_app_logos/okta-icon.svg"
import vertexaiIcon from "../../assets/img/icons/Agent_app_logos/vertex ai.svg"
import huggingfaceIcon from "../../assets/img/icons/Agent_app_logos/hugging-face.svg"
import codyIcon from "../../assets/img/icons/Agent_app_logos/cody.jpeg"
import perplexityIcon from "../../assets/img/icons/Agent_app_logos/Perplexity.svg"
import olamachatmodelIcon from "../../assets/img/icons/Agent_app_logos/Olama Chat model.svg"
import tavilyIcon from "../../assets/img/icons/Agent_app_logos/tavily.svg"
import mistralaiIcon from "../../assets/img/icons/Agent_app_logos/Mistral AI.svg"
import prometheusIcon from "../../assets/img/icons/Agent_app_logos/prometheus.svg"
import datadogIcon from "../../assets/img/icons/Agent_app_logos/Datadog.svg"
import sentryIcon from "../../assets/img/icons/Agent_app_logos/sentry.jpeg"
import webhookIcon from "../../assets/img/icons/Agent_app_logos/webhook.svg"
import notionIcon from "../../assets/img/icons/Agent_app_logos/Notion.svg"
import mongodbIcon from "../../assets/img/icons/Agent_app_logos/MongoDB.svg"
import mariadbIcon from "../../assets/img/icons/Agent_app_logos/mariadb.svg"
import bitbucketIcon from "../../assets/img/icons/Agent_app_logos/atlassian-bitbucket.png"
import apachekafkaIcon from "../../assets/img/icons/Agent_app_logos/Apache Kafka.svg"

const AGENT_APPS_DATA = [
  {
    "id": "microsoft",
    "name": "Microsoft Outlook",
    "icon": outlookIcon,
    "description": "Access and manage Outlook emails, calendar events, and contacts.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your Outlook connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Outlook connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "bitbucket",
    "name": "Bitbucket",
    "icon": bitbucketIcon,
    "description": "Manage Bitbucket repositories, pull requests, and CI/CD pipelines.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "devops-cicd",
    "configSchema": {
      "description": "Configure your Bitbucket connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Bitbucket connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    }
  },
  {
    "id": "google-gmail",
    "name": "Google Gmail",
    "icon": gmailIcon,
    "description": "Send, receive, and manage Gmail messages and email settings.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your Gmail connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Gmail connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "whatsapp",
    "name": "WhatsApp",
    "icon": whatsappIcon,
    "description": "Send and receive WhatsApp messages, manage contacts, and access chat history.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your WhatsApp connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this WhatsApp connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "slack",
    "name": "Slack",
    "icon": "https://cdn-icons-png.flaticon.com/512/2111/2111615.png",
    "description": "Send messages, manage channels, and access Slack workspace data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your Slack connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Slack connection",
          "required": true,
          "helpText": "Choose a name to identify this connection"
        },
        {
          "name": "channel_id",
          "type": "text",
          "label": "Channel Id",
          "placeholder": "Enter channel id",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "teams",
    "name": "Microsoft Teams",
    "icon": microsoftteamsIcon,
    "description": "Access Teams data, send messages, create meetings, and manage channels.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your Microsoft Teams connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection name",
          "placeholder": "Enter a name for this Microsoft Teams connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
        {
          "name": "team_id",
          "type": "text",
          "label": "Team Id",
          "placeholder": "Enter Team id",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
        {
          "name": "channel_id",
          "type": "text",
          "label": "Channel Id",
          "placeholder": "Enter Channel id",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "zoom",
    "name": "Zoom",
    "icon": zoomIcon,
    "description": "Schedule and manage Zoom meetings, access recordings, and manage participants.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your zoom connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Zoom connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    } 
  },
  {
    "id": "signal",
    "name": "Signal",
    "icon": signalIcon,
    "description": "Send secure messages and manage Signal conversations.",
    "status": "active",
    "actions": [
      "configure"
    ],
    "category": "email-communication"
  },
  {
    "id": "discord",
    "name": "Discord",
    "icon": discordIcon,
    "description": "Manage Discord servers, send messages, and access channel data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your Discord connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Discord connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    }
  },
  {
    "id": "twitter",
    "name": "Twitter",
    "icon": twitterIcon,
    "description": "Post tweets, manage followers, and access Twitter timeline data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication"
  },
  {
    "id": "telegram",
    "name": "Telegram",
    "icon": "https://cdn-icons-png.flaticon.com/512/2111/2111646.png",
    "description": "Send messages, manage channels, and access Telegram chat data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication"
  },
  {
    "id": "mailchimp",
    "name": "MailChimp",
    "icon": mailchimpIcon,
    "description": "Manage email campaigns, subscribers, and marketing automation.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication"
  },
  {
    "id": "linkedin",
    "name": "LinkedIn",
    "icon": "https://cdn-icons-png.flaticon.com/512/174/174857.png",
    "description": "Manage LinkedIn posts, connections, and professional network data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication",
    "configSchema": {
      "description": "Configure your LinkedIn connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this LinkedIn connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "pinterest",
    "name": "Pinterest",
    "icon": "https://cdn-icons-png.flaticon.com/512/174/174863.png",
    "description": "Manage Pinterest boards, pins, and access user profile data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication"
  },
  {
    "id": "twilio",
    "name": "Twilio",
    "icon": twilioIcon,
    "description": "Send SMS, make calls, and manage Twilio communication services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "email-communication"
  },
  {
    "id": "onedrive",
    "name": "Microsoft OneDrive",
    "icon": microsoftonedriveIcon,
    "description": "Upload, download, and manage files and folders in Microsoft OneDrive.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "zoho-workdrive",
    "name": "Zoho Work drive",
    "icon": zohoworkdriveIcon ,
    "description": "Access and manage files in Zoho WorkDrive with collaboration features.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "google-drive",
    "name": "Google Drive",
    "icon": "https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_48dp.png",
    "description": "Access, upload, download, and manage files and folders in Google Drive.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "google-books",
    "name": "Google Books",
    "icon": googlebooksIcon,
    "description": "Access Google Books library, search books, and manage reading lists.",
    "status": "active",
    "actions": [
      "configure"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "zoho-books",
    "name": "Zoho Books",
    "icon": zohobooksIcon,
    "description": "Manage accounting, invoices, and financial records in Zoho Books.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "dropbox",
    "name": "Dropbox",
    "icon": dropboxIcon,
    "description": "Upload, download, and manage files and folders in Dropbox.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration",
    "configSchema": {
      "description": "Configure your Dropbox connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Dropbox connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    }
  },
  {
    "id": "pinata",
    "name": "Pinata",
    "icon": pinataIcon,
    "description": "Manage IPFS file storage and pinning services with Pinata.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "nextcloud",
    "name": "Nextcloud",
    "icon": "https://nextcloud.com/favicon.ico",
    "description": "Access and manage files in self-hosted Nextcloud instances.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "file-storage-collaboration"
  },
  {
    "id": "excel",
    "name": "Microsoft Excel",
    "icon": "https://cdn-icons-png.flaticon.com/512/732/732220.png",
    "description": "Create, read, and update Excel spreadsheets and manage worksheet data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "sharepoint",
    "name": "Microsoft Sharepoint",
    "icon": sharepointIcon,
    "description": "Access and manage SharePoint sites, documents, and collaboration features.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "google-sheets",
    "name": "Google Sheets",
    "icon": "https://www.gstatic.com/images/branding/product/1x/sheets_2020q4_48dp.png",
    "description": "Create, read, and update Google Sheets spreadsheets and manage worksheet data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs",
    "configSchema": {
      "description": "Configure your Google Sheets connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Google Sheets connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "google-slides",
    "name": "Google Slides",
    "icon": "https://www.gstatic.com/images/branding/product/1x/slides_2020q4_48dp.png",
    "description": "Create, edit, and manage Google Slides presentations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "google-forms",
    "name": "Google Forms",
    "icon": "https://www.gstatic.com/images/branding/product/1x/forms_2020q4_48dp.png",
    "description": "Create and manage Google Forms, collect responses, and analyze form data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "craftmypdf",
    "name": "CraftMyPdf",
    "icon": "https://cdn-icons-png.flaticon.com/512/337/337946.png",
    "description": "Create and manage PDF documents with advanced formatting options.",
    "status": "active",
    "actions": [
      "configure"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "pdf-vector",
    "name": "Pdf Vector",
    "icon": pdfvectorIcon,
    "description": "Process and manage PDF documents with vector graphics support.",
    "status": "active",
    "actions": [
      "configure"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "typeform",
    "name": "Typeform",
    "icon": typeformIcon,
    "description": "Create interactive forms, surveys, and collect responses with Typeform.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "paperform",
    "name": "Paperform",
    "icon": paperformIcon,
    "description": "Create beautiful forms and collect responses with Paperform.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "invoice-ninja",
    "name": "Invoice Ninja",
    "icon": invoiceninjaIcon,
    "description": "Create and manage invoices, track payments, and handle billing.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "notion",
    "name": "Notion",
    "icon": notionIcon,
    "description": "Access and manage Notion pages, databases, and workspace content.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "spreadsheets-docs"
  },
  {
    "id": "mysql",
    "name": "MySQL",
    "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968313.png",
    "description": "Connect to MySQL databases, execute queries, and manage database operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "postgresql",
    "name": "PostgreSQL",
    "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968342.png",
    "description": "Connect to PostgreSQL databases, execute queries, and manage database operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "mongodb",
    "name": "MongoDB",
    "icon": mongodbIcon,
    "description": "Connect to MongoDB databases, manage collections, and execute queries.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "mariadb",
    "name": "MariaDB",
    "icon": mariadbIcon,
    "description": "Connect to MariaDB databases, execute queries, and manage database operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "aws-dynamodb",
    "name": "AWS DynamoDB",
    "icon": awsdynamoDBIcon,
    "description": "Access and manage AWS DynamoDB tables, items, and queries.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "the-hive",
    "name": "The Hive",
    "icon": thehiveIcon,
    "description": "Connect to The Hive database and manage data operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "supabase",
    "name": "Supabase",
    "icon": supabaseIcon,
    "description": "Access Supabase databases, manage tables, and execute queries.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "databases"
  },
  {
    "id": "aws",
    "name": "AWS",
    "icon": awsIcon ,
    "description": "Access AWS services, manage resources, and configure cloud infrastructure.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "aws-lambda",
    "name": "AWS Lambda",
    "icon": awslambdaIcon,
    "description": "Manage AWS Lambda functions, triggers, and serverless applications.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "aws-iam",
    "name": "AWS IAM",
    "icon": awsiamIcon,
    "description": "Manage AWS Identity and Access Management, users, roles, and permissions.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "aws-ses",
    "name": "AWS SES",
    "icon": awssesIcon,
    "description": "Send emails using AWS Simple Email Service and manage email configurations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "aws-sns",
    "name": "AWS SNS",
    "icon": awssnsIcon,
    "description": "Manage AWS Simple Notification Service, topics, and notifications.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "aws-transcribe",
    "name": "AWS Transcribe",
    "icon": "https://cdn-icons-png.flaticon.com/512/873/873107.png",
    "description": "Convert speech to text using AWS Transcribe service.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "s3-datadog",
    "name": "S3 Data Dog",
    "icon": s3datadogIcon,
    "description": "Monitor AWS S3 and integrate with Datadog for observability.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  // {
  //   "id": "big-data-cloud",
  //   "name": "Big Data Cloud",
  //   "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968332.png",
  //   "description": "Manage big data processing and cloud analytics services.",
  //   "status": "active",
  //   "actions": [
  //     "configure",
  //     "view-triggers"
  //   ],
  //   "category": "cloud-infrastructure"
  // },
  {
    "id": "google-cloud",
    "name": "Google Cloud",
    "icon": googlecloudIcon,
    "description": "Access Google Cloud Platform services and manage cloud resources.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "google-pubsub",
    "name": "Google Pub/Sub",
    "icon": googlepubsubIcon,
    "description": "Manage Google Cloud Pub/Sub messaging and event streaming.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "azure",
    "name": "Azure",
    "icon": azureIcon,
    "description": "Access Microsoft Azure services and manage cloud infrastructure.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "cloud-infrastructure"
  },
  {
    "id": "github",
    "name": "GitHub",
    "icon": "https://cdn-icons-png.flaticon.com/512/733/733553.png",
    "description": "Manage GitHub repositories, issues, pull requests, and workflows.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "devops-cicd",
    "configSchema": {
      "description": "Configure your Github connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Github connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    } 
  },
  {
    "id": "gitlab",
    "name": "GitLab",
    "icon": gitlabIcon,
    "description": "Manage GitLab repositories, CI/CD pipelines, and DevOps workflows.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "devops-cicd",
    "configSchema": {
      "description": "Configure your Gitlab connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Gitlab connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    }
  },
  {
    "id": "jenkins",
    "name": "Jenkins",
    "icon": jenkinsIcon,
    "description": "Manage Jenkins CI/CD pipelines, builds, and automation workflows.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "devops-cicd"
  },
  {
    "id": "salesforce",
    "name": "Salesforce",
    "icon": salesforceIcon,
    "description": "Access Salesforce CRM data, manage leads, opportunities, and accounts.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "crm-sales",
    "configSchema": {
      "description": "Configure your Salesforce connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Salesforce connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "hubspot",
    "name": "HubSpot",
    "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968875.png",
    "description": "Manage HubSpot CRM data including contacts, deals, and companies.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "crm-sales"
  },
  {
    "id": "zoho-crm",
    "name": "Zoho CRM",
    "icon": zohocrmIcon,
    "description": "Access Zoho CRM data, manage leads, contacts, and sales pipeline.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "crm-sales"
  },
  {
    "id": "zendesk",
    "name": "Zendesk",
    "icon": zendeskIcon,
    "description": "Manage Zendesk tickets, customer support, and help desk operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "crm-sales"
  },
  {
    "id": "pipedrive",
    "name": "Pipedrive",
    "icon": pipedriveIcon,
    "description": "Manage Pipedrive sales pipeline, deals, and customer relationships.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "crm-sales"
  },
  {
    "id": "asana",
    "name": "Asana",
    "icon": asanaIcon,
    "description": "Manage Asana projects, tasks, and team collaboration.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "project-management",
    "configSchema": {
      "description": "Configure your Asana connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Asana connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    }
  },
  {
    "id": "jira",
    "name": "Jira",
    "icon": jiraIcon,
    "description": "Manage Jira issues, sprints, and project tracking.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "project-management"
  },
  {
    "id": "confluence",
    "name": "Confluence",
    "icon": confluenceIcon,
    "description": "Access Confluence pages, documentation, and team knowledge base.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "project-management"
  },
  // {
  //   "id": "kanban",
  //   "name": "Kanban",
  //   "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968332.png",
  //   "description": "Manage Kanban boards and visualize workflow processes.",
  //   "status": "active",
  //   "actions": [
  //     "configure",
  //     "view-triggers"
  //   ],
  //   "category": "project-management"
  // },
  {
    "id": "trello",
    "name": "Trello",
    "icon": trelloIcon,
    "description": "Manage Trello boards, cards, and team collaboration.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "project-management"
  },
  {
    "id": "taiga",
    "name": "Taiga",
    "icon": taigaIcon,
    "description": "Manage Taiga projects, user stories, and agile project management.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "project-management"
  },
  {
    "id": "google-ads",
    "name": "Google Ads",
    "icon": googleadsIcon,
    "description": "Manage Google Ads campaigns, keywords, and advertising performance.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "marketing-social"
  },
  {
    "id": "facebook",
    "name": "Facebook",
    "icon": "https://cdn-icons-png.flaticon.com/512/174/174848.png",
    "description": "Manage Facebook pages, posts, and social media marketing.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "marketing-social"
  },
  {
    "id": "linkedin-marketing",
    "name": "LinkedIn",
    "icon": "https://cdn-icons-png.flaticon.com/512/174/174857.png",
    "description": "Manage LinkedIn marketing campaigns, posts, and professional networking.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "marketing-social",
    "configSchema": {
      "description": "Configure your LinkedIn connection",
      "oauth": true,
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this LinkedIn connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        },
      ]
    }
  },
  {
    "id": "adobe",
    "name": "Adobe",
    "icon": adobeIcon,
    "description": "Access Adobe Creative Cloud services and manage creative assets.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "marketing-social"
  },
  {
    "id": "google-youtube",
    "name": "YouTube",
    "icon": "https://cdn-icons-png.flaticon.com/512/174/174883.png",
    "description": "Manage YouTube channels, videos, and video marketing campaigns.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "marketing-social",
    "configSchema": {
      "description": "Configure your Google YouTube connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Google YouTube connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "shopify",
    "name": "Shopify",
    "icon": shopifyIcon,
    "description": "Manage Shopify stores, products, orders, and e-commerce operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "woocommerce",
    "name": "WooCommerce",
    "icon": woocommerceIcon,
    "description": "Manage WooCommerce stores, products, and e-commerce operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "big-cartel",
    "name": "Big Cartel",
    "icon": bigcartelIcon,
    "description": "Manage Big Cartel online stores and e-commerce operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "paypal",
    "name": "PayPal",
    "icon": paypalIcon,
    "description": "Process PayPal payments, manage transactions, and handle payment operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "stripe",
    "name": "Stripe",
    "icon": stripeIcon,
    "description": "Process Stripe payments, manage subscriptions, and handle payment operations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "coingecko",
    "name": "CoinGecko",
    "icon": coingeckoIcon,
    "description": "Access cryptocurrency market data and pricing information.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "groww",
    "name": "Groww",
    "icon": growwIcon,
    "description": "Manage investments and access financial services through Groww.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ecommerce-payments"
  },
  {
    "id": "kafka",
    "name": "KAFKA",
    "icon": apachekafkaIcon,
    "description": "Manage Kafka topics, consumer groups, and event streaming.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "messaging-streaming",
    "configSchema": {
      "description": "Configure your Kafka connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Name",
          "placeholder": "Enter a name for this Kafka connection",
          "required": true,
          "helpText": "A unique name for this Kafka connection"
        },
        {
          "name": "bootstrap_servers",
          "type": "text",
          "label": "Bootstrap Servers",
          "placeholder": "localhost:9092",
          "required": true,
          "helpText": "Kafka broker address used to establish the connection"
        },
        {
          "name": "topic_name",
          "type": "text",
          "label": "Topic Name",
          "placeholder": "workflow-events",
          "required": true,
          "helpText": "Kafka topic from which events will be consumed"
        },
        {
          "name": "consumer_group_id",
          "type": "text",
          "label": "Consumer Group",
          "placeholder": "superagentx-consumer",
          "required": true,
          "helpText": "Consumer group used to manage Kafka event consumption"
        },
        {
          "name": "security_protocol",
          "type": "select",
          "label": "Security Protocol",
          "required": false,
          "options": [
            {
              "value": "PLAINTEXT",
              "label": "Plain text"
            },
            {
              "value": "SSL",
              "label": "SSL"
            },
            {
              "value": "SASL_PLAINTEXT",
              "label": "SASL Plaintext"
            },
            {
              "value": "SASL_SSL",
              "label": "SASL SSL"
            }
          ],
          "helpText": "Security protocol used to connect to the Kafka broker"
        },
        {
          "name": "saslMechanism",
          "type": "select",
          "label": "SASL Mechanism",
          "required": true,
          "options": [
            {
              "value": "PLAIN",
              "label": "PLAIN"
            },
            {
              "value": "SCRAM-SHA-256",
              "label": "SCRAM-SHA-256"
            },
            {
              "value": "SCRAM-SHA-512",
              "label": "SCRAM-SHA-512"
            }
          ],
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SASL_PLAINTEXT",
              "SASL_SSL"
            ]
          },
          "helpText": "Authentication mechanism used for SASL"
        },
        {
          "name": "saslUsername",
          "type": "text",
          "label": "Username / API Key",
          "placeholder": "Enter username or API key",
          "required": true,
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SASL_PLAINTEXT",
              "SASL_SSL"
            ]
          },
          "helpText": "Username or API key used for Kafka authentication"
        },
        {
          "name": "saslPassword",
          "type": "password",
          "label": "Password / API Secret",
          "placeholder": "Enter password or API secret",
          "required": true,
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SASL_PLAINTEXT",
              "SASL_SSL"
            ]
          },
          "helpText": "Password or API secret used for Kafka authentication"
        },
        {
          "name": "keystoreLocation",
          "type": "text",
          "label": "Keystore Location",
          "placeholder": "/path/to/keystore.jks",
          "required": true,
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SSL"
            ]
          },
          "helpText": "Path to the Kafka SSL keystore"
        },
        {
          "name": "keystorePassword",
          "type": "password",
          "label": "Keystore Password",
          "placeholder": "Enter keystore password",
          "required": true,
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SSL"
            ]
          },
          "helpText": "Password for the SSL keystore"
        },
        {
          "name": "truststoreLocation",
          "type": "text",
          "label": "Truststore Location",
          "placeholder": "/path/to/truststore.jks",
          "required": true,
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SSL"
            ]
          },
          "helpText": "Path to the Kafka SSL truststore"
        },
        {
          "name": "truststorePassword",
          "type": "password",
          "label": "Truststore Password",
          "placeholder": "Enter truststore password",
          "required": true,
          "showWhen": {
            "field": "security_protocol",
            "values": [
              "SSL"
            ]
          },
          "helpText": "Password for the Kafka SSL truststore"
        }
      ]
    }
  },
  {
    "id": "rabbitmq",
    "name": "RabbitMQ",
    "icon": rabbitmqIcon,
    "description": "Manage RabbitMQ message queues and event streaming.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "messaging-streaming"
  },
  {
    "id": "posthog",
    "name": "PostHog",
    "icon": posthogIcon,
    "description": "Access PostHog product analytics and user behavior tracking.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "messaging-streaming"
  },
  {
    "id": "grafana",
    "name": "Grafana",
    "icon": grafanaIcon,
    "description": "Access Grafana dashboards and monitoring visualizations.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "analytics-monitoring"
  },
  {
    "id": "elasticsearch",
    "name": "Elastic Search",
    "icon":elasticsearchIcon,
    "description": "Search and analyze data using Elasticsearch search engine.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "analytics-monitoring"
  },
  {
    "id": "google-calendar",
    "name": "Google Calendar",
    "icon": "https://ssl.gstatic.com/images/branding/product/1x/calendar_2020q4_48dp.png",
    "description": "Integrate with Google Calendar to manage events, check availability, and access calendar data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "calendar-tasks",
    "configSchema": {
      "description": "Configure your Google Calendar connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Connection Name",
          "placeholder": "Enter a name for this Google Calendar connection",
          "required": true,
          "helpText": "Choose a descriptive name to identify this connection"
        }
      ]
    }
  },
  {
    "id": "google-tasks",
    "name": "Google Tasks",
    "icon": googletasksIcon,
    "description": "Manage Google Tasks, create to-do lists, and track task completion.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "calendar-tasks"
  },
  {
    "id": "todo",
    "name": "Microsoft To Do",
    "icon": microsofttodoIcon,
    "description": "Manage Microsoft To Do tasks, lists, and reminders.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "calendar-tasks"
  },
  {
    "id": "google-contacts",
    "name": "Google Contacts",
    "icon":googlecontactsIcon,
    "description": "Access and manage Google Contacts, sync contact information.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "calendar-tasks"
  },
  {
    "id": "dhl",
    "name": "DHL",
    "icon": dhlIcon,
    "description": "Track DHL shipments, manage logistics, and access shipping services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "shiphero",
    "name": "Ship Hero",
    "icon": shipheroIcon,
    "description": "Manage ShipHero warehouse operations and shipping logistics.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "google-translate",
    "name": "Google Translate",
    "icon": googletranslateIcon,
    "description": "Translate text and documents using Google Translate API.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "strava",
    "name": "Strava",
    "icon": stravaIcon,
    "description": "Access Strava fitness data, activities, and athlete information.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "godaddy",
    "name": "Go Daddy",
    "icon": godaddyIcon,
    "description": "Manage GoDaddy domains, hosting, and website services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  // {
  //   "id": "tinyurl",
  //   "name": "TinyURL",
  //   "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968332.png",
  //   "description": "Create and manage shortened URLs with TinyURL service.",
  //   "status": "active",
  //   "actions": [
  //     "configure",
  //     "view-triggers"
  //   ],
  //   "category": "logistics-utilities"
  // },
  {
    "id": "wikipedia",
    "name": "Wikipedia",
    "icon": wikipediaIcon,
    "description": "Access Wikipedia articles and knowledge base information.",
    "status": "active",
    "actions": [
      "configure"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "vimeo",
    "name": "Vimeo",
    "icon":vimeoIcon,
    "description": "Manage Vimeo videos, channels, and video hosting services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "samsung-smart-things",
    "name": "Samsung Smart Things",
    "icon": smarthingsIcon,
    "description": "Control Samsung SmartThings devices and home automation.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "spotify",
    "name": "Spotify",
    "icon": "https://cdn-icons-png.flaticon.com/512/174/174872.png",
    "description": "Access Spotify music data, playlists, and audio streaming services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "logistics-utilities"
  },
  {
    "id": "auth0",
    "name": "Auth0",
    "icon": Auth0Icon,
    "description": "Manage Auth0 authentication, users, and identity services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "auth"
  },
  {
    "id": "keycloak",
    "name": "Keycloak",
    "icon": keycloakIcon,
    "description": "Manage Keycloak identity and access management services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "auth"
  },
  {
    "id": "cognito",
    "name": "Cognito",
    "icon":cognitoIcon,
    "description": "Manage AWS Cognito user pools, authentication, and authorization.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "auth"
  },
  {
    "id": "okta",
    "name": "Okta",
    "icon": oktaIcon,
    "description": "Manage Okta identity and access management, users, and SSO.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "auth"
  },
  {
    "id": "vertex-ai",
    "name": "Vertex AI",
    "icon": vertexaiIcon,
    "description": "Access Google Vertex AI machine learning and AI services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  {
    "id": "huggingface",
    "name": "HuggingFace",
    "icon": huggingfaceIcon,
    "description": "Access HuggingFace AI models, transformers, and machine learning tools.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  {
    "id": "cody",
    "name": "Cody",
    "icon": codyIcon,
    "description": "Access Cody AI assistant and coding support services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  {
    "id": "perplexity",
    "name": "Perplexity",
    "icon": perplexityIcon,
    "description": "Access Perplexity AI search and question-answering services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  {
    "id": "olama-chat-model",
    "name": "Olama Chat model",
    "icon": olamachatmodelIcon,
    "description": "Access Ollama chat models and local AI inference.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  {
    "id": "tavily",
    "name": "Tavily",
    "icon": tavilyIcon,
    "description": "Access Tavily AI search and research services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  {
    "id": "mistral-ai",
    "name": "Mistral AI",
    "icon": mistralaiIcon,
    "description": "Access Mistral AI language models and AI services.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "ai"
  },
  // {
  //   "id": "ai-scraper",
  //   "name": "AI Scraper",
  //   "icon": "https://cdn-icons-png.flaticon.com/512/5968/5968332.png",
  //   "description": "Web scraping with AI-powered data extraction and processing.",
  //   "status": "active",
  //   "actions": [
  //     "configure",
  //     "view-triggers"
  //   ],
  //   "category": "ai"
  // },
  {
    "id": "prometheus",
    "name": "Prometheus",
    "icon": prometheusIcon,
    "description": "Access Prometheus metrics, monitoring, and alerting data.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "observability"
  },
  {
    "id": "datadog",
    "name": "Datadog",
    "icon": datadogIcon,
    "description": "Access Datadog monitoring, logs, and observability platform.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "observability"
  },
  {
    "id": "sentry",
    "name": "Sentry",
    "icon": sentryIcon,
    "description": "Access Sentry error tracking, performance monitoring, and debugging.",
    "status": "active",
    "actions": [
      "configure",
      "view-triggers"
    ],
    "category": "observability"
  },
  {
    "id": "open_api",
    "name": "Rest API",
    "icon": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iOCIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzBfMSkiLz4KPHBhdGggZD0iTTI0IDEyTDM2IDI0TDI0IDM2TDEyIDI0TDI0IDEyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTI0IDE4TDMwIDI0TDI0IDMwTDE4IDI0TDI0IDE4WiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzBfMSkiLz4KPHBhdGggZD0iTTI0IDIyTDI2IDI0TDI0IDI2TDIyIDI0TDI0IDIyWiIgZmlsbD0id2hpdGUiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8wXzEiIHgxPSIwIiB5MT0iMCIgeDI9IjQ4IiB5Mj0iNDgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzM2ODlGNSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM2MzY2RjEiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzBfMSIgeDE9IjE4IiB5MT0iMTgiIHgyPSIzMCIgeTI9IjMwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM4QjVDRjYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjN0MzQUVEIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+",
    "description": "Connect to REST API endpoints and configure API sources.",
    "status": "active",
    "actions": [
      "configure", "view-triggers"
    ],
    "category": "api-integrations",
    "configSchema": {
      "description": "Configure your REST API connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Name",
          "placeholder": "Enter a name for this REST API connection",
          "required": true,
          "helpText": "A unique name for your Pipeline"
        },
        {
          "name": "method",
          "type": "select",
          "label": "HTTP Method",
          "required": true,
          "options": [
            {
              "value": "GET",
              "label": "GET"
            },
            {
              "value": "POST",
              "label": "POST"
            },
            {
              "value": "PUT",
              "label": "PUT"
            },
            {
              "value": "DELETE",
              "label": "DELETE"
            }
          ]
        },
        {
          "name": "endpoint",
          "type": "text",
          "label": "Endpoint",
          "placeholder": "https://api.example.com/endpoint",
          "required": true,
          "helpText": "Rest endpoint URL"
        },
        {
          "name": "queryParams",
          "type": "keyvalue",
          "label": "Query Params",
          "required": false,
          "helpText": "Add query parameters as key-value pairs",
          "layout": "table"
        },
        {
          "name": "headers",
          "type": "keyvalue",
          "label": "Headers",
          "required": false,
          "helpText": "Add custom HTTP headers as key-value pairs",
          "layout": "table",
          "keyOptions": [
            "Content-Type", "Accept", "Content-Length", "Content-Encoding", "Authorization", "Proxy-Authorization", "Cache-Control", "If-Modified-Since", "ETag", "Connection", "Keep-Alive", "Upgrade", "Origin", "Referer", "User-Agent", "x-api-key", "x-auth-token", "x-request-id", "Accept-Encoding", "Accept-Language", "Cookie", "Set-Cookie", "Access-Control-Allow-Origin", "Access-Control-Allow-Headers"
          ],
          "valueOptionsByKey": {
            "content-type": [
              "application/json",
              "application/xml",
              "text/plain",
              "multipart/form-data",
              "application/x-www-form-urlencoded"
            ],
            "accept": [
              "application/json",
              "*/*",
              "text/html",
              "application/xml"
            ],
            "authorization": [
              "Bearer <token>",
              "Basic <base64>",
              "ApiKey <key>"
            ],
            "accept-encoding": [
              "gzip",
              "deflate",
              "br"
            ],
            "accept-language": [
              "en-US",
              "en-GB",
              "fr-FR"
            ],
            "cache-control": [
              "no-cache",
              "no-store",
              "max-age=0"
            ],
            "connection": [
              "keep-alive",
              "close"
            ],
            "access-control-allow-origin": [
              "*"
            ],
            "content-encoding": [
              "gzip",
              "compress",
              "br"
            ],
            "transfer-encoding": [
              "chunked"
            ]
          }
        },
        {
          "name": "body",
          "type": "payload",
          "label": "Payload",
          "placeholder": "{\n  \"key\": \"value\"\n}",
          "required": false,
          "helpText": "Request body payload in JSON format"
        }
      ]
    }
  },
  {
    "id": "webhook",
    "name": "Webhook",
    "icon": webhookIcon,
    "description": "Configure webhook endpoints to receive HTTP callbacks and trigger workflows.",
    "status": "active",
    "actions": [
      "configure", "view-triggers"
    ],
    "category": "api-integrations",
    "configSchema": {
      "description": "Configure your Webhook connection",
      "fields": [
        {
          "name": "name",
          "type": "text",
          "label": "Pipeline Name",
          "placeholder": "Enter a name for this webhook",
          "required": true,
          "helpText": "A unique name for your Pipeline"
        },
        {
          "name": "sourceType",
          "type": "select",
          "label": "Source Type",
          "required": true,
          "options": [
            {
              "value": "gmail",
              "label": "Gmail"
            },
            {
              "value": "slack",
              "label": "Slack"
            },
            {
              "value": "teams",
              "label": "Teams"
            },
            {
              "value": "github",
              "label": "GitHub"
            },
            {
              "value": "others",
              "label": "Others"
            }
          ],
          "helpText": "Select the source type for your webhook integration"
        },
        {
          "name": "eventNamePath",
          "type": "text",
          "label": "Event Name Path",
          "placeholder": "event",
          "required": true,
          "helpText": "The JSON path to root of event name in request"
        },
        {
          "name": "fieldsPath",
          "type": "text",
          "label": "Fields Path",
          "placeholder": "properties",
          "required": true,
          "helpText": "The JSON path to root of fields in request"
        },
        {
          "name": "basicAuthEnabled",
          "type": "checkbox",
          "label": "Basic Authentication",
          "required": false,
          "helpText": "This setting can't be updated after pipeline creation."
        },
        {
          "name": "basicAuthUsername",
          "type": "text",
          "label": "Basic Auth Username",
          "placeholder": "Username",
          "required": false,
          "helpText": "Username for Basic Authentication",
          "conditional": {
            "field": "basicAuthEnabled",
            "value": true
          }
        },
        {
          "name": "basicAuthPassword",
          "type": "password",
          "label": "Basic Auth Password",
          "placeholder": "Password",
          "required": false,
          "helpText": "Password for Basic Authentication",
          "conditional": {
            "field": "basicAuthEnabled",
            "value": true
          }
        }
      ]
    }
  }
]

export default AGENT_APPS_DATA;